import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DEFAULT_FONT = "'DM Sans', sans-serif";
export var UI = {
  shell: "#f4f5f7",
  panel: "#ffffff",
  panelBorder: "#e5e7eb",
  surface: "#f9fafb",
  surfaceBorder: "#e5e7eb",
  inputBg: "#ffffff",
  inputBorder: "#d1d5db",
  text: "#1f2937",
  textSecondary: "#4b5563",
  textMuted: "#6b7280",
  textFaint: "#9ca3af",
  tabTrack: "#f3f4f6",
  tabActive: "#ffffff",
  tabActiveText: "#111827",
  tabInactiveText: "#6b7280",
  accent: "#101828",
  canvas: "#eef0f3",
  canvasPaper: "#ffffff",
  shadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
  shadowMd: "0 4px 12px rgba(0, 0, 0, 0.08)"
};
export var panelFieldStyle = {
  width: "100%",
  background: UI.inputBg,
  border: "1px solid ".concat(UI.inputBorder),
  borderRadius: 6,
  color: UI.text,
  padding: "8px 12px",
  fontSize: 13,
  outline: "none",
  boxSizing: "border-box"
};
var ICON_PATHS = {
  blocks: "M4 4h7v7H4V4zm9 0h7v7h-7V4zM4 13h7v7H4v-7zm9 0h7v7h-7v-7z",
  templates: "M4 5h16v4H4V5zm0 6h10v8H4v-8zm12 0h4v8h-4v-8z",
  layers: "M12 2l9 5-9 5-9-5 9-5zm0 9l9 5-9 5-9-5 9-5zm0 9l9 5-9 5-9-5 9-5z",
  ai: "M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3zM5 17l.8 2.2L8 20l-2.2.8L5 23l-.8-2.2L2 20l2.2-.8L5 17zm14 0l.8 2.2L22 20l-2.2.8L19 23l-.8-2.2L16 20l2.2-.8L19 17z",
  settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9c.3.6.9 1 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z",
  close: "M18 6L6 18M6 6l12 12",
  document: "M8 3h8l4 4v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm8 1v4h4",
  timeline: "M12 3v18M6 8h12M6 16h8",
  hero: "M4 6h16M4 10h12M4 14h8",
  footer: "M4 18h16M6 14h12M8 10h8",
  megaphone: "M5 10v4h4l5 4V6L9 10H5zm9 2a3 3 0 0 0 0-4",
  anchor: "M12 3v14m-6-2a6 6 0 1 0 12 0",
  tag: "M4 12l8-8h6v6l-8 8-6-6z",
  fire: "M12 3s4 4 4 8a4 4 0 1 1-8 0c0-4 4-8 4-8z",
  lightbulb: "M12 3a5 5 0 0 1 5 5c0 2-1 3.5-2.5 4.5V14H9.5v-1.5C8 11.5 7 10 7 8a5 5 0 0 1 5-5zm-1 16h2"
};
export function BuilderIcon(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 1.75 : _ref$strokeWidth;
  switch (name) {
    case "heading":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M9.99984 6.66675V33.3334M29.9998 6.66675V33.3334M13.3332 6.66675H6.6665M29.9998 20.0001L9.99984 20.0001M13.3332 33.3334H6.6665M33.3332 33.3334H26.6665M33.3332 6.66675H26.6665",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "text":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M6.6665 11.6667C6.6665 10.1136 6.6665 9.33704 6.92024 8.72447C7.25855 7.90771 7.90747 7.2588 8.72423 6.92048C9.3368 6.66675 10.1134 6.66675 11.6665 6.66675H28.3332C29.8863 6.66675 30.6629 6.66675 31.2754 6.92048C32.0922 7.2588 32.7411 7.90771 33.0794 8.72447C33.3332 9.33704 33.3332 10.1136 33.3332 11.6667M14.9998 33.3334H24.9998M19.9998 6.66675V33.3334",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "image":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M27 35H11.5523C10.5426 35 10.0377 35 9.80397 34.8003C9.60113 34.6271 9.49348 34.3672 9.51441 34.1013C9.53853 33.7948 9.89552 33.4378 10.6095 32.7239L24.781 18.5523C25.4411 17.8923 25.7711 17.5622 26.1516 17.4386C26.4864 17.3298 26.847 17.3298 27.1817 17.4386C27.5622 17.5622 27.8923 17.8923 28.5523 18.5523L35 25V27M27 35C29.8003 35 31.2004 35 32.27 34.455C33.2108 33.9757 33.9757 33.2108 34.455 32.27C35 31.2004 35 29.8003 35 27M27 35H13C10.1997 35 8.79961 35 7.73005 34.455C6.78924 33.9757 6.02433 33.2108 5.54497 32.27C5 31.2004 5 29.8003 5 27V13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V27M17.5 14.1667C17.5 16.0076 16.0076 17.5 14.1667 17.5C12.3257 17.5 10.8333 16.0076 10.8333 14.1667C10.8333 12.3257 12.3257 10.8333 14.1667 10.8333C16.0076 10.8333 17.5 12.3257 17.5 14.1667Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "button":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M15.0002 5.83325V3.33325M8.4346 8.43435L6.66683 6.66659M8.4346 21.6666L6.66683 23.4344M21.6668 8.43435L23.4346 6.66659M5.8335 14.9999H3.3335M14.1668 14.1666L21.0187 35.4629L25.8335 30.6481L31.852 36.6666L36.6668 31.8518L30.6483 25.8333L35.4631 21.0184L14.1668 14.1666Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "spacer":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M20 30L20 10M25 26.6667L20 30L15 26.6667M25 13.3333L20 10L15 13.3333M35 5H5M35 35H5",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "divider":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M35 20H5",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "page-break":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M13 5H22.5L35 17.5V27C35 29.8003 35 31.2004 34.455 32.27C33.9757 33.2108 33.2108 33.9757 32.27 34.455C31.2004 35 29.8003 35 27 35H13C10.1997 35 8.79961 35 7.73005 34.455C6.78924 33.9757 6.02433 33.2108 5.54497 32.27C5 31.2004 5 29.8003 5 27V13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M22.5 5V13.5C22.5 16.3003 22.5 17.7004 23.045 18.77C23.5243 19.7108 24.2892 20.4757 25.23 20.955C26.2996 21.5 27.6997 21.5 30.5 21.5H35",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "gallery":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M14 5H7.66667C6.73325 5 6.26654 5 5.91002 5.18166C5.59641 5.34144 5.34144 5.59641 5.18166 5.91002C5 6.26654 5 6.73325 5 7.66667V14C5 14.9334 5 15.4001 5.18166 15.7567C5.34144 16.0703 5.59641 16.3252 5.91002 16.485C6.26654 16.6667 6.73325 16.6667 7.66667 16.6667H14C14.9334 16.6667 15.4001 16.6667 15.7567 16.485C16.0703 16.3252 16.3252 16.0703 16.485 15.7567C16.6667 15.4001 16.6667 14.9334 16.6667 14V7.66667C16.6667 6.73325 16.6667 6.26654 16.485 5.91002C16.3252 5.59641 16.0703 5.34144 15.7567 5.18166C15.4001 5 14.9334 5 14 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M32.3333 5H26C25.0666 5 24.5999 5 24.2433 5.18166C23.9297 5.34144 23.6748 5.59641 23.515 5.91002C23.3333 6.26654 23.3333 6.73325 23.3333 7.66667V14C23.3333 14.9334 23.3333 15.4001 23.515 15.7567C23.6748 16.0703 23.9297 16.3252 24.2433 16.485C24.5999 16.6667 25.0666 16.6667 26 16.6667H32.3333C33.2668 16.6667 33.7335 16.6667 34.09 16.485C34.4036 16.3252 34.6586 16.0703 34.8183 15.7567C35 15.4001 35 14.9334 35 14V7.66667C35 6.73325 35 6.26654 34.8183 5.91002C34.6586 5.59641 34.4036 5.34144 34.09 5.18166C33.7335 5 33.2668 5 32.3333 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M32.3333 23.3333H26C25.0666 23.3333 24.5999 23.3333 24.2433 23.515C23.9297 23.6748 23.6748 23.9297 23.515 24.2433C23.3333 24.5999 23.3333 25.0666 23.3333 26V32.3333C23.3333 33.2668 23.3333 33.7335 23.515 34.09C23.6748 34.4036 23.9297 34.6586 24.2433 34.8183C24.5999 35 25.0666 35 26 35H32.3333C33.2668 35 33.7335 35 34.09 34.8183C34.4036 34.6586 34.6586 34.4036 34.8183 34.09C35 33.7335 35 33.2668 35 32.3333V26C35 25.0666 35 24.5999 34.8183 24.2433C34.6586 23.9297 34.4036 23.6748 34.09 23.515C33.7335 23.3333 33.2668 23.3333 32.3333 23.3333Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14 23.3333H7.66667C6.73325 23.3333 6.26654 23.3333 5.91002 23.515C5.59641 23.6748 5.34144 23.9297 5.18166 24.2433C5 24.5999 5 25.0666 5 26V32.3333C5 33.2668 5 33.7335 5.18166 34.09C5.34144 34.4036 5.59641 34.6586 5.91002 34.8183C6.26654 35 6.73325 35 7.66667 35H14C14.9334 35 15.4001 35 15.7567 34.8183C16.0703 34.6586 16.3252 34.4036 16.485 34.09C16.6667 33.7335 16.6667 33.2668 16.6667 32.3333V26C16.6667 25.0666 16.6667 24.5999 16.485 24.2433C16.3252 23.9297 16.0703 23.6748 15.7567 23.515C15.4001 23.3333 14.9334 23.3333 14 23.3333Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "list":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M33 19.5L15.6667 19.5M33 10.5L15.6667 10.5M33 28.5L15.6667 28.5M9.88889 19.5C9.88889 20.3284 9.24219 21 8.44444 21C7.6467 21 7 20.3284 7 19.5C7 18.6716 7.6467 18 8.44444 18C9.24219 18 9.88889 18.6716 9.88889 19.5ZM9.88889 10.5C9.88889 11.3284 9.24219 12 8.44444 12C7.6467 12 7 11.3284 7 10.5C7 9.67157 7.6467 9 8.44444 9C9.24219 9 9.88889 9.67157 9.88889 10.5ZM9.88889 28.5C9.88889 29.3284 9.24219 30 8.44444 30C7.6467 30 7 29.3284 7 28.5C7 27.6716 7.6467 27 8.44444 27C9.24219 27 9.88889 27.6716 9.88889 28.5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "social":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M6.6665 13.3333H33.3332M6.6665 26.6667H33.3332M13.3332 5V35M26.6665 5V35",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "code":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M26.5 25.8889L33 19.5L26.5 13.1111M13.5 13.1111L7 19.5L13.5 25.8889M22.6 8L17.4 31",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "column":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M11.3333 5H10.3333C8.46649 5 7.53307 5 6.82003 5.36331C6.19282 5.68289 5.68289 6.19282 5.36331 6.82003C5 7.53307 5 8.46649 5 10.3333V29.6667C5 31.5335 5 32.4669 5.36331 33.18C5.68289 33.8072 6.19282 34.3171 6.82003 34.6367C7.53307 35 8.46649 35 10.3333 35H11.3333C13.2002 35 14.1336 35 14.8466 34.6367C15.4738 34.3171 15.9838 33.8072 16.3034 33.18C16.6667 32.4669 16.6667 31.5335 16.6667 29.6667V10.3333C16.6667 8.46649 16.6667 7.53307 16.3034 6.82003C15.9838 6.19282 15.4738 5.68289 14.8466 5.36331C14.1336 5 13.2002 5 11.3333 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M29.6667 5H28.6667C26.7998 5 25.8664 5 25.1534 5.36331C24.5262 5.68289 24.0162 6.19282 23.6966 6.82003C23.3333 7.53307 23.3333 8.46649 23.3333 10.3333V29.6667C23.3333 31.5335 23.3333 32.4669 23.6966 33.18C24.0162 33.8072 24.5262 34.3171 25.1534 34.6367C25.8664 35 26.7998 35 28.6667 35H29.6667C31.5335 35 32.4669 35 33.18 34.6367C33.8072 34.3171 34.3171 33.8072 34.6367 33.18C35 32.4669 35 31.5335 35 29.6667V10.3333C35 8.46649 35 7.53307 34.6367 6.82003C34.3171 6.19282 33.8072 5.68289 33.18 5.36331C32.4669 5 31.5335 5 29.6667 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "one-column":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V27C35 29.8003 35 31.2004 34.455 32.27C33.9757 33.2108 33.2108 33.9757 32.27 34.455C31.2004 35 29.8003 35 27 35H13C10.1997 35 8.79961 35 7.73005 34.455C6.78924 33.9757 6.02433 33.2108 5.54497 32.27C5 31.2004 5 29.8003 5 27V13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "table":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M7 15.6667H33M7 24.3333H33M20 7V33M13.9333 7H26.0667C28.4936 7 29.707 7 30.634 7.4723C31.4494 7.88776 32.1122 8.55067 32.5277 9.36604C33 10.293 33 11.5064 33 13.9333V26.0667C33 28.4936 33 29.707 32.5277 30.634C32.1122 31.4494 31.4494 32.1122 30.634 32.5277C29.707 33 28.4936 33 26.0667 33H13.9333C11.5064 33 10.293 33 9.36604 32.5277C8.55067 32.1122 7.88776 31.4494 7.4723 30.634C7 29.707 7 28.4936 7 26.0667V13.9333C7 11.5064 7 10.293 7.4723 9.36604C7.88776 8.55067 8.55067 7.88776 9.36604 7.4723C10.293 7 11.5064 7 13.9333 7Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "star":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M18.8046 5.75561C19.1887 4.97738 19.3808 4.58826 19.6415 4.46394C19.8684 4.35577 20.132 4.35577 20.3588 4.46394C20.6196 4.58826 20.8117 4.97738 21.1958 5.75561L24.8403 13.1389C24.9537 13.3686 25.0104 13.4835 25.0932 13.5727C25.1666 13.6517 25.2546 13.7157 25.3524 13.7611C25.4628 13.8125 25.5895 13.831 25.843 13.868L33.9951 15.0596C34.8536 15.1851 35.2828 15.2478 35.4815 15.4575C35.6543 15.6399 35.7356 15.8906 35.7027 16.1397C35.6649 16.426 35.3541 16.7287 34.7326 17.334L28.8359 23.0774C28.6521 23.2565 28.5602 23.346 28.5009 23.4525C28.4484 23.5468 28.4147 23.6504 28.4017 23.7576C28.387 23.8786 28.4087 24.0051 28.4521 24.258L29.8434 32.3703C29.9902 33.2259 30.0636 33.6537 29.9257 33.9076C29.8057 34.1285 29.5924 34.2834 29.3453 34.3292C29.0612 34.3819 28.677 34.1798 27.9087 33.7758L20.6208 29.9431C20.3937 29.8237 20.2802 29.764 20.1606 29.7406C20.0547 29.7198 19.9457 29.7198 19.8398 29.7406C19.7202 29.764 19.6067 29.8237 19.3796 29.9431L12.0917 33.7758C11.3234 34.1798 10.9392 34.3819 10.6551 34.3292C10.408 34.2834 10.1947 34.1285 10.0747 33.9076C9.93683 33.6537 10.0102 33.2259 10.157 32.3703L11.5483 24.258C11.5917 24.0051 11.6134 23.8786 11.5987 23.7576C11.5857 23.6504 11.552 23.5468 11.4995 23.4525C11.4402 23.346 11.3483 23.2565 11.1645 23.0774L5.26776 17.334C4.64627 16.7287 4.33552 16.426 4.29771 16.1397C4.26481 15.8906 4.34609 15.6399 4.51891 15.4575C4.71755 15.2478 5.14678 15.1851 6.00524 15.0596L14.1573 13.868C14.4109 13.831 14.5376 13.8125 14.648 13.7611C14.7458 13.7157 14.8338 13.6517 14.9071 13.5727C14.99 13.4835 15.0467 13.3686 15.1601 13.1389L18.8046 5.75561Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "quote":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M11.6667 14.1667H20M11.6667 20H25M16.1396 30H27C29.8003 30 31.2004 30 32.27 29.455C33.2108 28.9757 33.9757 28.2108 34.455 27.27C35 26.2004 35 24.8003 35 22V13C35 10.1997 35 8.79961 34.455 7.73005C33.9757 6.78924 33.2108 6.02433 32.27 5.54497C31.2004 5 29.8003 5 27 5H13C10.1997 5 8.79961 5 7.73005 5.54497C6.78924 6.02433 6.02433 6.78924 5.54497 7.73005C5 8.79961 5 10.1997 5 13V33.8925C5 34.7806 5 35.2246 5.18205 35.4527C5.34037 35.651 5.58045 35.7664 5.83423 35.7661C6.12605 35.7658 6.47278 35.4884 7.16626 34.9337L11.142 31.7531C11.9542 31.1033 12.3603 30.7784 12.8125 30.5474C13.2137 30.3425 13.6407 30.1927 14.082 30.1021C14.5794 30 15.0995 30 16.1396 30Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "notification":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M20 23.3333V17.5M20 11.6667H20.0167M16.5 32L18.9333 35.2444C19.2952 35.7269 19.4761 35.9682 19.6979 36.0544C19.8922 36.13 20.1078 36.13 20.3021 36.0544C20.5239 35.9682 20.7048 35.7269 21.0667 35.2444L23.5 32C23.9886 31.3486 24.2329 31.0228 24.5308 30.7742C24.9281 30.4426 25.3972 30.2081 25.9008 30.0892C26.2786 30 26.6857 30 27.5 30C29.8297 30 30.9946 30 31.9134 29.6194C33.1386 29.1119 34.1119 28.1386 34.6194 26.9134C35 25.9946 35 24.8297 35 22.5V13C35 10.1997 35 8.79961 34.455 7.73005C33.9757 6.78924 33.2108 6.02433 32.27 5.54497C31.2004 5 29.8003 5 27 5H13C10.1997 5 8.79961 5 7.73005 5.54497C6.78924 6.02433 6.02433 6.78924 5.54497 7.73005C5 8.79961 5 10.1997 5 13V22.5C5 24.8297 5 25.9946 5.3806 26.9134C5.88807 28.1386 6.86144 29.1119 8.08658 29.6194C9.00544 30 10.1703 30 12.5 30C13.3143 30 13.7214 30 14.0992 30.0892C14.6028 30.2081 15.0719 30.4426 15.4692 30.7742C15.7671 31.0228 16.0114 31.3486 16.5 32Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "card":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M36.6668 15H3.3335M3.3335 13L3.3335 27C3.3335 29.8003 3.3335 31.2004 3.87846 32.2699C4.35783 33.2108 5.12273 33.9757 6.06354 34.455C7.1331 35 8.53323 35 11.3335 35H28.6668C31.4671 35 32.8672 35 33.9368 34.455C34.8776 33.9757 35.6425 33.2108 36.1219 32.27C36.6668 31.2004 36.6668 29.8003 36.6668 27V13C36.6668 10.1997 36.6668 8.79961 36.1219 7.73005C35.6425 6.78924 34.8776 6.02434 33.9368 5.54497C32.8672 5 31.4671 5 28.6668 5L11.3335 5C8.53323 5 7.1331 5 6.06354 5.54497C5.12273 6.02433 4.35783 6.78924 3.87846 7.73005C3.3335 8.79961 3.3335 10.1997 3.3335 13Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "three-column":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M15 5V35M25 5V35M13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V27C35 29.8003 35 31.2004 34.455 32.27C33.9757 33.2108 33.2108 33.9757 32.27 34.455C31.2004 35 29.8003 35 27 35H13C10.1997 35 8.79961 35 7.73005 34.455C6.78924 33.9757 6.02433 33.2108 5.54497 32.27C5 31.2004 5 29.8003 5 27V13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "logos":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M20.0002 34.1203C21.7693 35.7038 24.1056 36.6666 26.6668 36.6666C32.1897 36.6666 36.6668 32.1895 36.6668 26.6666C36.6668 22.055 33.5453 18.1726 29.2999 17.0169M10.7005 17.0169C6.45505 18.1725 3.3335 22.055 3.3335 26.6666C3.3335 32.1894 7.81065 36.6666 13.3335 36.6666C18.8563 36.6666 23.3335 32.1894 23.3335 26.6666C23.3335 25.3658 23.0851 24.1229 22.6332 22.983M30.0002 13.3333C30.0002 18.8561 25.523 23.3333 20.0002 23.3333C14.4773 23.3333 10.0002 18.8561 10.0002 13.3333C10.0002 7.8104 14.4773 3.33325 20.0002 3.33325C25.523 3.33325 30.0002 7.8104 30.0002 13.3333Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "accordion":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M5 15H35M5 25H35M13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V27C35 29.8003 35 31.2004 34.455 32.27C33.9757 33.2108 33.2108 33.9757 32.27 34.455C31.2004 35 29.8003 35 27 35H13C10.1997 35 8.79961 35 7.73005 34.455C6.78924 33.9757 6.02433 33.2108 5.54497 32.27C5 31.2004 5 29.8003 5 27V13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "testimonials":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M5 13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V22C35 24.8003 35 26.2004 34.455 27.27C33.9757 28.2108 33.2108 28.9757 32.27 29.455C31.2004 30 29.8003 30 27 30H22.8062C21.7662 30 21.2461 30 20.7487 30.1021C20.3074 30.1927 19.8803 30.3425 19.4791 30.5474C19.0269 30.7784 18.6209 31.1033 17.8087 31.7531L13.8329 34.9337C13.1395 35.4884 12.7927 35.7658 12.5009 35.7661C12.2471 35.7664 12.007 35.651 11.8487 35.4527C11.6667 35.2246 11.6667 34.7806 11.6667 33.8925V30C10.1167 30 9.34174 30 8.7059 29.8296C6.98044 29.3673 5.63271 28.0196 5.17037 26.2941C5 25.6583 5 24.8833 5 23.3333V13Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.9949 12.8321C18.4953 11.1007 15.9948 10.6349 14.116 12.2204C12.2372 13.8058 11.9727 16.4567 13.4481 18.3318C14.3622 19.4935 16.6565 21.6153 18.2699 23.0616C18.8626 23.5929 19.1589 23.8585 19.5145 23.9655C19.8196 24.0574 20.1701 24.0574 20.4752 23.9655C20.8308 23.8585 21.1271 23.5929 21.7198 23.0616C23.3332 21.6152 25.6275 19.4935 26.5416 18.3318C28.017 16.4567 27.7848 13.7892 25.8737 12.2204C23.9626 10.6516 21.4944 11.1007 19.9949 12.8321Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "icon-block":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.9887 8.55969C16.6565 4.664 11.0997 3.61607 6.92465 7.18336C2.74957 10.7506 2.16178 16.715 5.44049 20.934C8.16652 24.4418 16.4164 31.8402 19.1203 34.2347C19.4228 34.5026 19.5741 34.6366 19.7505 34.6892C19.9045 34.7351 20.073 34.7351 20.227 34.6892C20.4034 34.6366 20.5547 34.5026 20.8572 34.2347C23.561 31.8402 31.811 24.4418 34.537 20.934C37.8157 16.715 37.2997 10.7131 33.0528 7.18336C28.806 3.6536 23.321 4.664 19.9887 8.55969Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "cta":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M15.0002 5.83325V3.33325M8.4346 8.43435L6.66683 6.66659M8.4346 21.6666L6.66683 23.4344M21.6668 8.43435L23.4346 6.66659M5.8335 14.9999H3.3335M26.441 26.9825L22.2881 34.695C21.8136 35.5761 21.5764 36.0166 21.291 36.128C21.0433 36.2247 20.7644 36.1974 20.5401 36.0545C20.2817 35.8899 20.1344 35.4117 19.8399 34.4554L14.0755 15.742C13.8348 14.9608 13.7145 14.5701 13.8113 14.3063C13.8957 14.0765 14.0768 13.8954 14.3066 13.8111C14.5704 13.7143 14.961 13.8346 15.7422 14.0752L34.4555 19.8397C35.4119 20.1343 35.8901 20.2816 36.0547 20.5399C36.1976 20.7642 36.2249 21.0431 36.1282 21.2908C36.0168 21.5762 35.5762 21.8134 34.6952 22.2879L26.9828 26.4407C26.8519 26.5112 26.7864 26.5465 26.7291 26.5918C26.6782 26.632 26.6322 26.678 26.592 26.7288C26.5467 26.7861 26.5115 26.8516 26.441 26.9825Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "cover":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M13.3333 11.6667H26.6667M20 11.6667V28.3333M13 35H27C29.8003 35 31.2004 35 32.27 34.455C33.2108 33.9757 33.9757 33.2108 34.455 32.27C35 31.2004 35 29.8003 35 27V13C35 10.1997 35 8.79961 34.455 7.73005C33.9757 6.78924 33.2108 6.02433 32.27 5.54497C31.2004 5 29.8003 5 27 5H13C10.1997 5 8.79961 5 7.73005 5.54497C6.78924 6.02433 6.02433 6.78924 5.54497 7.73005C5 8.79961 5 10.1997 5 13V27C5 29.8003 5 31.2004 5.54497 32.27C6.02433 33.2108 6.78924 33.9757 7.73005 34.455C8.79961 35 10.1997 35 13 35Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "pricing":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M14.1668 24.4444C14.1668 26.5921 15.9079 28.3333 18.0557 28.3333H21.6668C23.968 28.3333 25.8335 26.4678 25.8335 24.1666C25.8335 21.8654 23.968 19.9999 21.6668 19.9999H18.3335C16.0323 19.9999 14.1668 18.1344 14.1668 15.8333C14.1668 13.5321 16.0323 11.6666 18.3335 11.6666H21.9446C24.0924 11.6666 25.8335 13.4077 25.8335 15.5555M20.0002 9.16659V11.6666M20.0002 28.3333V30.8333M36.6668 19.9999C36.6668 29.2047 29.2049 36.6666 20.0002 36.6666C10.7954 36.6666 3.3335 29.2047 3.3335 19.9999C3.3335 10.7952 10.7954 3.33325 20.0002 3.33325C29.2049 3.33325 36.6668 10.7952 36.6668 19.9999Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "signature":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M33 29.0797L31.5554 30.6772C30.7893 31.5242 29.7502 32 28.6669 32C27.5835 32 26.5445 31.5242 25.7784 30.6772C25.0111 29.8318 23.9722 29.3572 22.8892 29.3572C21.8061 29.3572 20.7672 29.8318 20 30.6772M7 32H9.41879C10.1254 32 10.4787 32 10.8112 31.9193C11.1059 31.8478 11.3877 31.7298 11.6462 31.5696C11.9377 31.389 12.1876 31.1365 12.6872 30.6314L30.8334 12.2877C32.03 11.0781 32.03 9.11687 30.8334 7.90723C29.6368 6.69759 27.6967 6.69759 26.5001 7.90723L8.35382 26.2509C7.85418 26.756 7.60436 27.0085 7.42571 27.3033C7.26731 27.5645 7.15059 27.8494 7.07982 28.1474C7 28.4835 7 28.8406 7 29.5549V32Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "timeline":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("circle", {
          cx: "12",
          cy: "11",
          r: "3.5",
          stroke: color,
          strokeWidth: strokeWidth
        }), /*#__PURE__*/_jsx("circle", {
          cx: "12",
          cy: "21",
          r: "3.5",
          stroke: color,
          strokeWidth: strokeWidth
        }), /*#__PURE__*/_jsx("circle", {
          cx: "12",
          cy: "31",
          r: "3.5",
          stroke: color,
          strokeWidth: strokeWidth
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 15V17M12 25V27M19 11H32M19 21H30M19 31H27",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "left":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M13.3333 8.33333H2.5M16.6667 5H2.5M16.6667 11.6667H2.5M13.3333 15H2.5",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "right":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M17.5 8.33333H6.66671M17.5 5H3.33337M17.5 11.6667H3.33337M17.5 15H6.66671",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "center":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M15 8.33333H5M17.5 5H2.5M17.5 11.6667H2.5M15 15H5",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "exit":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M8 7L3 12L8 17M3 12H15M15 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H15",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "copy":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M16 16V18.8C16 19.9201 16 20.4802 15.782 20.908C15.5903 21.2843 15.2843 21.5903 14.908 21.782C14.4802 22 13.9201 22 12.8 22H5.2C4.0799 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V11.2C2 10.0799 2 9.51984 2.21799 9.09202C2.40973 8.71569 2.71569 8.40973 3.09202 8.21799C3.51984 8 4.0799 8 5.2 8H8M11.2 16H18.8C19.9201 16 20.4802 16 20.908 15.782C21.2843 15.5903 21.5903 15.2843 21.782 14.908C22 14.4802 22 13.9201 22 12.8V5.2C22 4.0799 22 3.51984 21.782 3.09202C21.5903 2.71569 21.2843 2.40973 20.908 2.21799C20.4802 2 19.9201 2 18.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.07989 8 5.2V12.8C8 13.9201 8 14.4802 8.21799 14.908C8.40973 15.2843 8.71569 15.5903 9.09202 15.782C9.51984 16 10.0799 16 11.2 16Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "paste":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("rect", {
          x: "9",
          y: "3",
          width: "6",
          height: "4",
          rx: "1",
          stroke: color,
          strokeWidth: strokeWidth
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 11v6M9 14h6",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "duplicate":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "delete":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "lock":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("rect", {
          x: "5",
          y: "11",
          width: "14",
          height: "10",
          rx: "2",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M8 11V8a4 4 0 0 1 8 0v3",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "unlock":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("rect", {
          x: "5",
          y: "11",
          width: "14",
          height: "10",
          rx: "2",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M8 11V8a4 4 0 0 1 7.5-1.9",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "align-left":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M20 12.5H8M12.5 8L8 12.5L12.5 17",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M4 5V19.5455",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "align-center":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M22 12H15M18.75 8L15 12L18.75 16",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M12 5V19.5455",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M2 12H9M5.25 8L9 12L5.25 16",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "align-right":
      return /*#__PURE__*/_jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: [/*#__PURE__*/_jsx("path", {
          d: "M4 12.5H16M11.5 8L16 12.5L11.5 17",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /*#__PURE__*/_jsx("path", {
          d: "M20 5V19.5455",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "add":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 5V19M5 12H19",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "arrow-up":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 19V5M5 12l7-7 7 7",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "arrow-down":
      return /*#__PURE__*/_jsx("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          display: "block"
        },
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 5v14M19 12l-7 7-7-7",
          stroke: color,
          strokeWidth: strokeWidth,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "blocks":
    case "templates":
    case "layers":
    case "ai":
    case "settings":
    case "close":
    case "document":
    case "hero":
    case "footer":
    case "megaphone":
    case "anchor":
    case "tag":
    case "fire":
    case "lightbulb":
      {
        var d = ICON_PATHS[name];
        if (!d) return null;
        return /*#__PURE__*/_jsx("svg", {
          width: size,
          height: size,
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          style: {
            display: "block"
          },
          children: /*#__PURE__*/_jsx("path", {
            d: d,
            stroke: color,
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });
      }
    default:
      return null;
  }
}